// pages/PersonalData/components/Step1Choose/Step1Choose.tsx
import React from 'react';
import DataCard from '../DataCard/DataCard';
import Button from 'shared/ui/Button/Button';
import { Button_Style, Button_Type } from 'shared/ui/Button/Button';
import { ReactComponent as IconEmail } from 'assets/img/icons/icon_email_small.svg';
import { ReactComponent as IconPhone } from 'assets/img/icons/icon_phone.svg';
import { ReactComponent as IconInfo } from 'assets/img/icons/icon_Info.svg';
import './Step1Choose.scss';

interface Step1ChooseProps {
  selectedTypes: string[];
  onSelect: (types: string[]) => void;
  onNext: () => void;
}

const Step1Choose: React.FC<Step1ChooseProps> = ({
                                                   selectedTypes,
                                                   onSelect,
                                                   onNext
                                                 }) => {
  const handleToggleType = (type: string) => {
    if (selectedTypes.includes(type)) {
      onSelect(selectedTypes.filter(t => t !== type));
    } else {
      onSelect([...selectedTypes, type]);
    }
  };

  const isNextDisabled = selectedTypes.length === 0;

  return (
    <div className="step1-choose">
      <div className="step1-choose__header">
        <h2 className="step1-choose__title">
          Quelles données souhaitez-vous protéger ?
        </h2>
        <p className="step1-choose__subtitle">
          Sélectionnez les types de données que vous voulez surveiller et protéger
        </p>
      </div>

      <div className="step1-choose__cards">
        <DataCard
          icon={<IconEmail />}
          title="Adresses email"
          description="Protégez vos adresses email contre les fuites et le spam"
          selected={selectedTypes.includes('email')}
          onClick={() => handleToggleType('email')}
        />

        <DataCard
          icon={<IconPhone />}
          title="Numéros de téléphone"
          description="Surveillez vos numéros de téléphone et recevez des alertes"
          selected={selectedTypes.includes('phoneNumber')}
          onClick={() => handleToggleType('phoneNumber')}
        />
      </div>

      {selectedTypes.length > 0 && (
        <div className="step1-choose__info">
          <IconInfo className="step1-choose__info-icon" />
          <span className="step1-choose__info-text">
                        Vous allez pouvoir {selectedTypes.includes('email') && 'ajouter vos emails'}
            {selectedTypes.includes('email') && selectedTypes.includes('phoneNumber') && ' et '}
            {selectedTypes.includes('phoneNumber') && 'ajouter vos numéros de téléphone'}
                    </span>
        </div>
      )}

      <div className="step1-choose__actions">
        <Button
          label="Continuer"
          type={Button_Type.PRIMARY}
          style={Button_Style.SOLID}
          onClick={onNext}
          disabled={isNextDisabled}
          className="step1-choose__next-btn"
        />
      </div>
    </div>
  );
};

export default Step1Choose;